import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { AppProviders } from './AppProviders';
import { applyInitialTheme } from './theme/themeScript';

import './styles/reset.css';
import './styles/tokens.css';
import './styles/themes/light.css';
import './styles/themes/dark.css';
import './styles/typography.css';
import './styles/quill-compat.css';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element #root was not found.');
}

if (!document.documentElement.dataset.theme) {
  applyInitialTheme();
}

createRoot(rootElement).render(
  <StrictMode>
    <AppProviders />
  </StrictMode>,
);
